import type {Colors, Theme} from '@travel-frontend/themes';

import {css, type Interpolation} from '@emotion/react';
import {LabelXSmall} from '@travel-frontend/ui-components';

import {HelpTooltip} from '@/components/HelpTooltip';
import {TooltipMarkdown} from '@/components/TooltipMarkdown';

const labelOverride: Interpolation<Theme> = css`
  text-wrap: pretty;
  z-index: 0;
`;

const tooltipOverride: Interpolation<Theme> = css`
  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
`;

type Props = {hint?: string; hintTooltip?: string; textColor?: keyof Colors};

export const HintElement = ({
  hint,
  hintTooltip,
  textColor = 'contentInversePrimary',
}: Props) => {
  if (!hint) return null;

  return (
    <LabelXSmall color={textColor} css={labelOverride}>
      {hint}{' '}
      {hintTooltip && (
        <HelpTooltip
          onClick={(event) => event.stopPropagation()}
          css={tooltipOverride}
          content={<TooltipMarkdown value={hintTooltip} />}
        />
      )}
    </LabelXSmall>
  );
};
